<template>
  <div>
    <el-dialog
      title="Manage Plan"
      :visible.sync="IsManageplan"
      width="75%"
      class="custel"
    >
      <!-- :before-close="handleClose" -->
      <ManagePlanPopup />
    </el-dialog>
    <div class="flex gap-4 lg:items-center custtbbor">
      <img
        src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
        alt="img"
        class="planimg sm-planimg rounded-full"
      />
      <div class="lg:flex justify-between items-center">
        <div>
          <div class="flex gap-2 items-center">
            <h2 class="text-black fsize24 sm-fsize20px font-high">
              <!-- Essential Plan -->{{ userPlan.membershipName }}
            </h2>
            <p class="bg-d5fde1 text-black font-medium px-3 rounded-full">
              <!-- Active -->
              {{ userPlan.membershipStatus.toUpperCase() }}
            </p>
          </div>
          <p class="fsize14">
            Manage your subscription with actions such as upgrade, renewal and
            cancellation.
          </p>
        </div>
        <div @click="managePlan" class="lg:pt-0 md:pt-0 pt-2">
          <base-button outline type="primary" class="w-48 rounded-full"
            >Manage Subscription</base-button
          >
        </div>
      </div>
    </div>

    <div>
      <h2 class="fsize20 text-black font-medium pt-5">Subscription Plan</h2>
      <div class="pt-3">
        <table class="custhtmltab">
          <tr>
            <th>Plan</th>
            <!-- <td>Essential Plan</td> -->
            <td>{{ userPlan.membershipName }}</td>
          </tr>

          <tr>
            <th>Plan Status</th>

            <!-- <td>Active</td> -->
            <td>
              {{ userPlan.membershipStatus.toUpperCase() }}
            </td>
          </tr>
          <tr>
            <th>Terms</th>

            <!-- <td>One year</td> -->
            <td v-if="userPlan.userId.currentMembership != null">
              {{
                (new Date(userPlan.userId.membershipValidity).getFullYear() -
                  new Date(userPlan.createdAt).getFullYear()) *
                  12 +
                (new Date(userPlan.userId.membershipValidity).getMonth() -
                  new Date(userPlan.createdAt).getMonth())
              }}
              months
            </td>
            <td v-else>-</td>
          </tr>
          <tr>
            <th>Start Date</th>

            <!-- <td>Jult 26, 2023</td> -->
            <td>
              {{
                new Date(userPlan.createdAt).toLocaleDateString("en-Gb", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })
              }}
            </td>
          </tr>
          <tr>
            <th>End Date</th>

            <!-- <td>July 26, 2024</td> -->
            <td v-if="userPlan.userId.currentMembership != null">
              {{
                new Date(userPlan.userId.membershipValidity).toLocaleDateString(
                  "en-Gb",
                  {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  }
                )
              }}
            </td>
            <td v-else>-</td>
          </tr>
        </table>
      </div>
    </div>
    <h2 class="fsize20 text-black font-medium pt-5">Invoice</h2>
    <div class="pt-3">
      <el-table border :data="getAllPayments.result" style="width: 100%">
        <el-table-column
          prop="invoiceid"
          label="Invoice ID"
          min-width="180px"
          v-slot="{ row }"
        >
          {{ row.orderId }}
        </el-table-column>
        <el-table-column
          prop="date"
          label="Date"
          min-width="140px"
          v-slot="{ row }"
        >
          {{
            new Date(row.createdAt).toLocaleDateString("en-Gb", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })
          }}
        </el-table-column>
        <el-table-column
          prop="status"
          label="Status"
          min-width="100px"
          v-slot="{ row }"
        >
          {{ row.membershipStatus.toUpperCase() }}
        </el-table-column>
        <el-table-column
          prop="amount"
          min-width="100px"
          label="Amount"
          v-slot="{ row }"
        >
          {{ row.price }}
        </el-table-column>
        <!-- <el-table-column label="Invoice" class="item-center" min-width="100px">
          <template>
            <feather-icon icon="DownloadIcon" />
          </template>
        </el-table-column> -->
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ManagePlanPopup from "./components/ManagePlanPopup.vue";
export default {
  components: {
    ManagePlanPopup,
  },
  data() {
    return {
      IsManageplan: false,
      tableData: [
        {
          invoiceid: 1,
          date: "12-12-23",
          status: "Complete",
          amount: "2959.00",
        },
      ],
      userPlan: null,
      todaysDate: new Date(),
    };
  },
  computed: {
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
    ...mapState("payment", { getAllPayments: "getAllPayments" }),
  },
  methods: {
    managePlan() {
      if (this.userPlan.membershipStatus !== "active") {
        this.$router.push({ name: "subscribe1" });
      } else {
        this.IsManageplan = true;
      }
    },
    async getData() {
      try {
        await this.$store.dispatch("payment/getAllPayments", {
          userId: this.getUserByUserId._id,
        });
        this.userPlan = this.getAllPayments.result[0];
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style>
@media (max-width: 640px) {
  .sm-planimg {
    width: 40px !important;
    height: 40px !important;
  }
  .custel .el-dialog {
    width: 95% !important;
  }
}
.planimg {
  width: 80px;
  height: 80px;
}
.bg-d5fde1 {
  background: #d5fde1;
}
.custtbbor {
  border: 1px solid #cacaca;
  padding: 10px;
  border-radius: 8px;
}
.custhtmltab {
  border-collapse: collapse;

  width: 100%;
}

.custhtmltab td,
th {
  border: 1px solid #eaeaee;

  text-align: left;

  padding: 8px;
}

.custhtmltab tr:nth-child(odd) {
  background-color: #f7f9fa;
}
</style>
